import {gql} from '@apollo/client'

export interface ACAVerificationRecord {
  id: string
  paymentStatus: string
  paymentMethod: string
  billingActionTaken: string
  pendingDocuments: string
  docsActionTaken: string
  incomeModification: string
  contactInfo: string
  result: string
  openTicketsDetail: string
  additionalNotes: string
  created: string
  updated: string
  createdBy?: {id: string; firstName: string; lastName: string} | null
  updatedBy?: {id: string; firstName: string; lastName: string} | null
}

export interface IResACAVerifications {
  acaVerificationsByPolicy: ACAVerificationRecord[]
}

const ACA_VERIFICATION_FIELDS = `
  id
  paymentStatus
  paymentMethod
  billingActionTaken
  pendingDocuments
  docsActionTaken
  incomeModification
  contactInfo
  result
  openTicketsDetail
  additionalNotes
  created
  updated
  createdBy { id firstName lastName }
  updatedBy { id firstName lastName }
`

export const GET_ACA_VERIFICATIONS_BY_POLICY = gql`
  query acaVerificationsByPolicy($policyId: Int!) {
    acaVerificationsByPolicy(policyId: $policyId) {
      ${ACA_VERIFICATION_FIELDS}
    }
  }
`
